import React, { Fragment, useState } from "react";
import { set_page_state } from "../../../../redux/actions/PageStateAction";
import { set_store } from "../../../../redux/actions/CreateStoreAction";
import { connect } from "react-redux";
import { FileUploadPromise } from "../../../../utils/aws_s3/aws_s3";
import DropzoneElement from "../../../../components/Dropzone/DropzoneElement";
import { type } from "../../../../components/Dropzone/type";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";
import { apiJson } from "../../../../api/Api";

const DocumentSchema = Yup.object().shape({
  business_name: Yup.string().required("Required"),
  business_type: Yup.string().required("Required"),
  license_no: Yup.string().required("Required"),
  businsess_license_file: Yup.string().required("Required"),
});

const DocumentForm = (props) => {
  const [data, setData] = useState(true);
  const documentValues = {
    business_name: props.store?.business_name || "",
    business_type: props.store?.business_type || "",
    license_no: props.store?.license_no || "",
    businsess_license_file: props.store?.businsess_license_file || "",
  };

  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const nextClick = (values) => {
    apiJson.createStore
      .updateStoreDocuments({
        business_name: values.business_name,
        business_type: values.business_type,
        license_no: values.license_no,
        businsess_license_file: values.businsess_license_file
      })
      .then(response => {
        if (response.success) {
          props.set_store({
            store: {
              ...props.store,
              business_name: values.business_name,
              business_type: values.business_type,
              license_no: values.license_no,
              businsess_license_file: values.businsess_license_file,
            },
          });
          props.set_page_state({ pageState: { id: 4 } });
        }
        else {
          message = response.message;
          showError();
        }
      })
      .catch(error => {
        message = "Something went wrong!";
        showError();
      });
  };

  const handleFilesChange = (e, setFieldValue) => {
    setData(false);
    FileUploadPromise(e[0])
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          setFieldValue("businsess_license_file", response.location);
          setData(true);
        }
      })
      .catch((error) => {
        setData(true);
        message = error
          ? error !== ""
            ? error
            : "something went wrong"
          : "something went wrong";
        showError();
      });
  };

  return (
    <Fragment>
      <Formik
        initialValues={documentValues}
        validationSchema={DocumentSchema}
        enableReinitialize={true}
        isValidating={true}
        onSubmit={(values) => nextClick(values)}
      >
        {({ touched, errors, setFieldValue, values }) => {
          return (
            <Form className="form mx-auto">
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="business_name"
                type="text"
                label="Business Name"
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="business_type"
                type="text"
                label="Type"
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="license_no"
                type="text"
                label="License No."
              />
              {data ? (
                <Fragment>
                  <DropzoneElement
                    multiple={false}
                    updateSelectedServiceFiles={(e) =>
                      handleFilesChange(e, setFieldValue)
                    }
                    value={
                      values.businsess_license_file !== ""
                        ? "bussinessfile.pdf"
                        : "Select Bussiness License File(pdf)"
                    }
                    type={type.PDF}
                  />
                  {touched.businsess_license_file &&
                    errors.businsess_license_file && (
                      <div
                        className="error"
                        style={{
                          position: "relative",
                          left: "0",
                          color: "#f44336",
                          marginTop: "3px",
                          fontSize: "0.75rem",
                        }}
                      >
                        {errors.businsess_license_file}
                      </div>
                    )}
                </Fragment>
              ) : (
                <div className="d-flex justify-content-center align-items-center w-100 h-100">
                  <ClipLoader color="#000" loading size={35} />
                </div>
              )}
              <br />
              <button key={2412} type="submit" className="next-button">
                Next
              </button>
            </Form>
          );
        }}
      </Formik>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
  };
};

const mapDispatchTopProps = { set_store, set_page_state };

export default connect(mapStateToProps, mapDispatchTopProps)(DocumentForm);
